<div class="ccorbit-form-group without-icon cm-layout">
  <div class="cm-body">
  <div class="row g-0">

    <!-- ── Sección: Configuración básica ── -->
    <div class="col-12 mb-2">
      <div class="row text-center g-2">
        
        <div class="col-xl-4">
          <label class="field-label">Mercados</label>
          <app-mercado-select [mercados]="mercados"
            [restringirCuentaMetaapi]="restringirCuentaMetaapi"
            [(ngModel)]="selectedIdMercado"
            [disabled]="isLoadingMetaapi"
            (change)="changeInput('idMercado', $event)">
          </app-mercado-select>
        </div>
        <div class="col-xl-4">
          <label class="field-label">Frecuencia</label>
          <select class="form-control form-control-sm ccorbit-input listas"
            (change)="changeInput('period', selectedFrecuency)"
            [(ngModel)]="selectedFrecuency">
            <option *ngFor="let frec of frecuencySelect" [ngValue]="frec.idperiodo">
              {{frec.periodo}}
            </option>
          </select>
        </div>
        <div class="col-xl-4">
          <label class="field-label">Fecha inicial</label>
          <input type="date" name="fecha" class="form-control form-control-sm ccorbit-input"
            (change)="changeInput('fechaInicio', $event)" (input)="onFechaInput($event)" (keydown)="onFechaKeydown($event)" [value]="fechaInicial"
            [min]="fechaMinimaDisponible" [max]="today">
          <span class="badge bg-secondary ms-1" *ngIf="horaSuscripcionFormateada as hora" title="Hora de la suscripción">
            {{ hora }}
          </span>
        </div>
      </div>
      <!-- Progreso descarga MetaAPI — ancho completo -->
      <div *ngIf="isLoadingMetaapi" class="d-flex flex-column gap-1 mt-2">
        <small class="text-center" style="color: var(--nec-text-muted)">Descargando {{ candlesDownloadSymbol || 'datos' }} {{ descargaFuente === 'fmp' ? 'FMP' : 'MetaAPI' }}{{ candlesDownloadFase ? ' — ' + faseLabel(candlesDownloadFase) : '' }}...</small>
        <mat-progress-bar
          [mode]="candlesDownloadExpected > 0 ? 'determinate' : 'indeterminate'"
          [value]="candlesDownloadExpected > 0 ? (candlesDownloadTotal / candlesDownloadExpected) * 100 : 0"
          color="primary" style="border-radius:4px;">
        </mat-progress-bar>
        <small *ngIf="candlesDownloadExpected > 0" class="d-block text-center" style="color: var(--nec-text-muted)">
          {{candlesDownloadTotal | number:'1.0-0'}} / {{candlesDownloadExpected | number:'1.0-0'}} {{ descargaFuente === 'fmp' ? 'activos' : 'velas' }}
          ({{(candlesDownloadTotal / candlesDownloadExpected) * 100 | number:'1.0-0'}}%)
        </small>
      </div>
      <!-- Aviso broker desconectado — ancho completo -->
      <div *ngIf="selectedMercadoIsMetaapi && !metaapiConnected && !isLoadingMetaapi"
           class="d-flex align-items-center gap-2 mt-2 px-2 py-1 rounded"
           style="background:rgba(255,160,0,0.12); border:1px solid rgba(255,160,0,0.4)">
        <mat-icon style="font-size:16px;width:16px;height:16px;color:#ffa000;flex-shrink:0">warning</mat-icon>
        <small style="color:#ffa000; flex:1">Se necesita conectarse al broker para usar datos MetaApi.</small>
        <button type="button" class="btn btn-warning btn-sm py-0 px-2" style="font-size:12px;white-space:nowrap" (click)="openBrokerLogin()">Conectar</button>
      </div>
    </div>

    <!-- ── Sección: Índice y Volatilidad ── -->
    <div class="col-12 filter-section mb-2">
      <div class="cm-section-header filters-header">
        <div class="filters-title">
          <mat-icon>filter_list</mat-icon>
          Filtros de mercado
        </div>
        <button type="button" class="btn-add-filter" (click)="toggleAddFilterMenu()" matTooltip="Agregar filtro">
          <span aria-hidden="true">+</span> Filtro
        </button>
      </div>

      <div class="add-filter-menu" *ngIf="showAddFilterMenu">
        <button type="button" class="add-filter-option" (click)="addMarketFilter('Indice')" [disabled]="!!planificadorsv.showIndice">
          + Indice
        </button>
        <button type="button" class="add-filter-option" (click)="addMarketFilter('Volatilidad')" [disabled]="!!planificadorsv.showVolatilidad">
          + Volatilidad
        </button>
      </div>

      <div class="filter-row active-filter" *ngIf="!!planificadorsv.showIndice">
        <div class="filter-chip">
          Indice
          <button type="button" class="chip-remove" (click)="removeMarketFilter('Indice')" matTooltip="Quitar Indice">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <select class="form-control form-control-sm ccorbit-input listas filter-select"
          (change)="buscarCompania('Indice')"
          [(ngModel)]="idMercadoIndice">
          <option [ngValue]="mercado.idmercado" *ngFor="let mercado of mercados">{{mercado.iso}} ({{mercado.activos}})</option>
        </select>
        <select class="form-control form-control-sm ccorbit-input listas filter-select"
          (change)="registrarCompania('IndiceActivo', $event)"
          [(ngModel)]="idActivoIndice">
          <option [ngValue]="mercado.idNectum" *ngFor="let mercado of companiasIndice">{{mercado.iso}}</option>
        </select>
      </div>

      <div class="filter-row active-filter mt-2" *ngIf="!!planificadorsv.showVolatilidad">
        <div class="filter-chip">
          Volatilidad
          <button type="button" class="chip-remove" (click)="removeMarketFilter('Volatilidad')" matTooltip="Quitar Volatilidad">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <select class="form-control form-control-sm ccorbit-input listas filter-select"
          (change)="buscarCompania('Volatilidad')"
          [(ngModel)]="idMercadovolatilidad">
          <option [ngValue]="mercado.idmercado" *ngFor="let mercado of mercados">{{mercado.iso}} ({{mercado.activos}})</option>
        </select>
        <select class="form-control form-control-sm ccorbit-input listas filter-select"
          (change)="registrarCompania('VolatilidadActivo', $event)"
          [(ngModel)]="idActivoVolatilidad">
          <option [ngValue]="mercado.idNectum" *ngFor="let mercado of companiasVolatilidad">{{mercado.iso}}</option>
        </select>
      </div>
    </div>

    <!-- ── Sección: Tipo de estrategia / Periódico ── -->
    <!-- En modo screener no interviene: se busca qué compañías cumplen hoy, no cómo se opera. -->
    <ng-container *ngIf="isModelsRoute && !screener">
      <div class="col-12">
        <div class="param-row">
          <label class="fw-semibold gray-color mb-0">Tipo de estrategia</label>
          <mat-button-toggle-group class="cm-toggle-group" [value]="bajista ? 'bajista' : 'alcista'"
            (change)="onTipoEstrategiaChange($event)">
            <mat-button-toggle value="alcista">Alcista</mat-button-toggle>
            <mat-button-toggle value="bajista">Bajista</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      <div class="col-12 bajistaspan">
        <mat-slide-toggle #periodicoToggleAnchor [(ngModel)]="periodico" class="gray-color"
          (change)="changeInput('periodico', $event)" (mouseenter)="openPeriodicoPanel()">Estrategia Periódica</mat-slide-toggle>
      </div>
    </ng-container>

    <!-- ── Sección: Opciones Periódico (panel flotante) ── -->
    <ng-template #periodicoPanel>
      <div class="periodico-section">
        <div class="cm-section-header periodico-panel-header">
          <mat-icon>repeat</mat-icon>
          Configuración periódica
          <button type="button" class="periodico-panel-close" (click)="closePeriodicoPanel()" mat-icon-button>
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div class="param-row">
          <div class="param-label-group">
            <label class="fw-semibold gray-color mb-0">Periodos Sucesivos</label>
            <mat-slide-toggle [(ngModel)]="todosSelected" (change)="onTodosChange($event)">Todos</mat-slide-toggle>
          </div>
          <input type="number" class="text-center param-input"
            [(ngModel)]="Modelformdata.periodoModeloPeriodico"
            (change)="changeInput('periodoModeloPeriodico', $event)">
        </div>
        <div class="param-row">
          <label class="fw-semibold gray-color mb-0">Primer Periodo</label>
          <input type="number" class="text-center param-input"
            [(ngModel)]="optimalWallet.capitales[0]"
            (change)="actualizarcapitalinicial()">
        </div>
        <div class="param-row">
          <label class="fw-semibold gray-color mb-0">Periodos Sucesivos</label>
          <input type="number" class="text-center param-input"
            [(ngModel)]="optimalWallet.capitales[1]"
            (change)="changeInput('periodosucesivo', $event)">
        </div>
        <div class="param-row">
          <label class="fw-semibold gray-color mb-0">No Condiciones</label>
          <mat-slide-toggle [(ngModel)]="planificadorsv.noCondiciones" class="gray-color"></mat-slide-toggle>
        </div>
        <div class="param-row">
          <label class="fw-semibold gray-color mb-0">Asignar Capital</label>
          <mat-slide-toggle [(ngModel)]="asignarCapital" class="gray-color"
            (change)="changeInput('asignarCapital', $event)"></mat-slide-toggle>
        </div>
        <div class="param-row">
          <label class="fw-semibold gray-color mb-0">Entradas Repetidas</label>
          <mat-slide-toggle [(ngModel)]="repeticionEntradas" class="gray-color"
            (change)="changeInput('repeticionEntradas', $event)"
            [disabled]="planificadorsv.noCondiciones"></mat-slide-toggle>
        </div>
      </div>
    </ng-template>

    <!-- ── Sección: Indicadores y Condiciones ── -->
    <div class="col-12 indicators-section mb-2">
      <div class="cm-section-header">
        <mat-icon>manage_search</mat-icon>
        Indicadores & condiciones
      </div>
      <app-indicators (frecuencia)="getFrecuency($event)" [isModelsRoute]="isModelsRoute"></app-indicators>
    </div>

    <!-- ── Tus condiciones ── -->
    <div class="col-12">
      <div class="tablacondiciones">
        <span>Tus condiciones</span>
        <div class="elementoscontainer" *ngFor="let item of this.planificadorsv.condiciones">
          <div class="elemento">
            <span *ngIf="!editing">{{item[0]}}</span>
            <input *ngIf="editing" type="text" [(ngModel)]="item[0]" class="form-control form-control-sm">
            <button *ngIf="!editing" (click)="startEditing(item)"
              [disabled]="item[1]==='Indice' || item[1]==='Volatilidad'"
              mat-icon-button class="cond-icon-btn">
              <mat-icon>edit</mat-icon>
            </button>
            <button *ngIf="editing" (click)="finishEditing(item)" mat-icon-button class="cond-icon-btn">
              <mat-icon>check</mat-icon>
            </button>
            <span class="condition-type-badge">{{item[1]}}</span>
            <button *ngIf="!editing" (click)="removeCondition(item)"
              mat-icon-button class="cond-icon-btn cond-remove-btn">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Sección: Salida (Stop Loss / Profit / Días) ── -->
    <!-- Oculta en screener: la búsqueda es de entradas en una fecha, no hay operación que cerrar. -->
    <ng-container *ngIf="isModelsRoute && !screener">
      <div class="col-12 exit-controls">
        <div class="cm-section-header">
          <mat-icon>output</mat-icon>
          Condiciones de salida
        </div>
        <!-- Stop Loss -->
        <div class="exit-control-row">
          <div class="exit-toggles">
            <mat-slide-toggle [ngModel]="stopLoss"
              (change)="actualizarSlideStoploss($event)">Stop Loss</mat-slide-toggle>
            <mat-slide-toggle [ngModel]="stopLossDinamico"
              (change)="actualizarSlideStoplossDinamico($event)"
              [disabled]="!stopLoss">Dinámico</mat-slide-toggle>
          </div>
          <input type="number" class="exit-input"
            (change)="changeInput('stoploss', $event)"
            [(ngModel)]="stopLossValue" min="0">
        </div>
        <!-- Profit -->
        <div class="exit-control-row">
          <div class="exit-toggles">
            <mat-slide-toggle [ngModel]="proFit"
              (change)="actualizarSlideProfit($event)">Profit</mat-slide-toggle>
          </div>
          <input type="number" class="exit-input"
            (change)="changeInput('profit', $event)"
            [(ngModel)]="proFitValue" min="0">
        </div>
        <!-- Días Salida -->
        <div class="exit-control-row">
          <div class="exit-toggles">
            <mat-slide-toggle [ngModel]="diasSalida"
              (change)="actualizarSlideDiasSalida($event)">Días Salida</mat-slide-toggle>
          </div>
          <input type="number" class="exit-input"
            (change)="changeInput('diasSalida', $event)"
            [(ngModel)]="diasSalidaValue" min="0">
        </div>
        <div class="exit-control-row">
          <div class="exit-toggles">
            <mat-slide-toggle [ngModel]="salidaFinDia"
              (change)="actualizarSlideSalidaFinDia($event)">Salida fin de día</mat-slide-toggle>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ── Alerta validación ── -->
    <div *ngIf="isInValidModel" class="col-12 mt-1">
      <div class="alert alert-warning d-flex align-items-center gap-2 py-2" role="alert">
        <i class="ri-error-warning-fill"></i>
        Faltan campos por diligenciar
      </div>
    </div>

    <!-- ── Opciones no-modelo (estadísticas) ── -->
    <div *ngIf="!isModelsRoute" class="col-12">
      <div class="row g-2 mb-2">
        <div class="col-6">
          <mat-checkbox [color]="'primary'" [(ngModel)]="Modelformdata.diadesemana">
            <label class="fw-semibold gray-color">Día de la Semana {{diasemanaliteral}}</label>
          </mat-checkbox>
        </div>
        <div class="col-6">
          <mat-checkbox [color]="'primary'" [(ngModel)]="Modelformdata.diashabiles">
            <label class="fw-semibold gray-color">Solo Días Hábiles</label>
          </mat-checkbox>
        </div>
        <div class="col-6">
          <label class="fw-semibold gray-color">Rango %</label>
        </div>
        <div class="col-6">
          <input type="number" class="listas input" [(ngModel)]="Modelformdata.rangoPorcentualEvaluar">
        </div>
        <div class="col-6">
          <label class="fw-semibold gray-color">Días</label>
        </div>
        <div class="col-6">
          <input type="number" class="listas input" [(ngModel)]="Modelformdata.diasEvaluar">
        </div>
      </div>
    </div>


  </div>
  </div>

  <!-- ── Botón principal (sticky footer) ── -->
  <div class="cm-footer">
    <button [disabled]="activatedModelo || earningsActive || (selectedMercadoIsMetaapi && !metaapiConnected)" (click)="generateModel()" mat-flat-button
      class="ccorbit d-block fw-semibold generate-btn">
      <mat-icon class="me-1">{{ screener ? 'search' : (isModelsRoute ? 'play_arrow' : 'analytics') }}</mat-icon>
      {{ screener ? 'Buscar' : (isModelsRoute ? 'Generar Modelo' : 'Funcion Estadísticas') }}
    </button>
  </div>
</div>
